// Shared look of the code editors (source view, sketch JSON).
import { HighlightStyle } from '@codemirror/language';
import { EditorView } from '@codemirror/view';
import { tags as t } from '@lezer/highlight';

export const highlight = HighlightStyle.define([
  { tag: [t.keyword, t.modifier, t.controlKeyword, t.operatorKeyword], color: 'var(--accent)' },
  { tag: [t.string, t.special(t.string)], color: 'var(--added)' },
  { tag: [t.number, t.bool, t.null, t.atom], color: 'var(--changed)' },
  { tag: [t.comment, t.meta], color: 'var(--text-faint)', fontStyle: 'italic' },
  { tag: [t.typeName, t.className, t.definition(t.typeName)], color: 'var(--text)' },
  { tag: [t.variableName, t.propertyName], color: 'var(--text)' },
]);

export const editorTheme = EditorView.theme({
  '&': { background: 'var(--bg)', color: 'var(--text)' },
  '.cm-gutters': { background: 'var(--bg)', color: 'var(--text-faint)', border: 'none' },
  '.cm-activeLine': { background: 'var(--hover)' },
  '.cm-activeLineGutter': { background: 'transparent', color: 'var(--text-muted)' },
  '.cm-selectionBackground, &.cm-focused .cm-selectionBackground': { background: 'var(--accent-soft) !important' },
  '.cm-searchMatch': { background: 'var(--changed-soft)', outline: '1px solid var(--changed)' },
  '.cm-panels': { background: 'var(--panel-2)', color: 'var(--text)', borderColor: 'var(--border)' },
  '.cm-panels input, .cm-panels button': { fontFamily: 'var(--font-sans)', fontSize: '12px' },
  '.cm-content': { caretColor: 'var(--accent)' },
  '.cm-tooltip': { background: 'var(--panel-2)', color: 'var(--text)', border: '1px solid var(--border-strong)', borderRadius: '6px' },
  '.cm-diagnostic': { fontFamily: 'var(--font-sans)', fontSize: '12px', padding: '4px 8px' },
  '.cm-diagnosticText': { whiteSpace: 'pre-wrap' },
  '.cm-tooltip-autocomplete ul li': { fontFamily: 'var(--font-sans)', fontSize: '12.5px', padding: '2px 8px' },
  '.cm-tooltip-autocomplete ul li[aria-selected]': { background: 'var(--active)', color: 'var(--text)' },
  '.cm-completionDetail': { color: 'var(--text-faint)', fontStyle: 'normal', marginLeft: '8px' },
});
